<script setup>
import { ref } from "vue"
import { PaintBrushIcon } from '@heroicons/vue/24/solid'
import { SecondaryButton } from "@codinglabsau/ui"
import Modal from "@/Components/Inputs/BlockEditor/Extension/Components/Modal.vue"
import ToolbarButton from "@/Components/Inputs/BlockEditor/Extension/Components/ToolbarButton.vue"
import PresetCard from "@/Components/Inputs/BlockEditor/Extension/Components/Card/PresetCard.vue";

const props = defineProps({
  size: {
    required: true,
  },
  padding: {
    required: true,
  },
})

let showDialogue = ref(false)

const emits = defineEmits(['update:size', 'update:padding'])

const presets = [
  {
    name: 'Preset One',
    description: 'Large thumbnail and medium padding.',
    attributes: {
      size: 24,
      padding: 4,
    }
  },
  {
    name: 'Preset Two',
    description: 'Small thumbnail and thin padding.',
    attributes: {
      size: 10,
      padding: 2,
    }
  },
]

const setPreset = (preset) => {
  emits('update:size', preset.attributes.size)
  emits('update:padding', preset.attributes.padding)
  showDialogue.value = false
}
</script>

<template>
  <ToolbarButton :label="__('Choose Preset')" :icon="PaintBrushIcon" v-model="showDialogue"/>
  <Modal v-model="showDialogue">
    <template #title>
      {{ __('Card Presets') }}
    </template>
    <template #description>
      {{ __('Choose a preset') }}
    </template>
    <div v-for="preset in presets">
      <span class="text-gray-600 text-lg">{{ preset.name }}</span>
      <PresetCard
        @click="setPreset(preset)"
        :padding="preset.attributes.padding"
        :size="preset.attributes.size"
        class="hover:bg-gray-300 rounded-xl cursor-pointer"
      >
        <template #content>
          <h1>Title</h1>
          <p>
            {{ preset.description }}
          </p>
        </template>
      </PresetCard>
    </div>
    <SecondaryButton class="mt-2" type="button" @click.prevent="showDialogue = false">{{ __('Close') }}</SecondaryButton>
  </Modal>
</template>
